module.exports = __webpack_public_path__ + "static/media/Royal-logo.f2b793a0.svg";